import React, { useState } from "react";

import { ITimespan, ITimespanProps } from "components/dashboard/product-template-table/utils/interfaces";
import TimeSpanInputs from "components/fragments/product-template-configurator/ProductTemplateAttributesConfiguration/type-fields/components/TimeSpanInputs";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { T } from "services/lang/LanguageService";
import { convertTimeSpanToString, secondsToTimeSpan, TimeSpan, timeSpanToSeconds } from "utils/time-utils";
import "./style.css";

export default function Timespan(props: ITimespanProps) {
  const [currentTimeSpan, setCurrentTimeSpan] = useState<ITimespan>(props.timespan || {});
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const timespan = props.timespan || {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  const handleChangeEvent = (val: number) => {
    setCurrentTimeSpan(secondsToTimeSpan(val));
  };

  const handleSaveTimeSpan = () => {
    props.changeHandler(currentTimeSpan);
    setIsDialogVisible(false);
  };

  const handleCloseDialog = () => {
    setCurrentTimeSpan(props.timespan || {});
    setIsDialogVisible(false);
  };

  const footerTemplate = () => (
    <div className="flex justify-content-end gap-2 mt-3">
      <Button
        label={T("action.cancel")}
        icon="pi pi-times"
        className="component-editor-button icon-red"
        onClick={handleCloseDialog}
      />
      <Button
        label={T("action.save")}
        icon="pi pi-check"
        className="component-editor-button icon-green"
        onClick={handleSaveTimeSpan}
      />
    </div>
  );

  if (props.isInEditMode) {
    return (
      <>
        <Button
          label={convertTimeSpanToString(timespan)}
          className="bg-gray-300 border-none text-black-alpha-90 hover:bg-gray-400 hover:text-white w-full"
          onClick={() => setIsDialogVisible(true)}
        />
        <Dialog
          header={T("header.timespan")}
          footer={footerTemplate}
          visible={isDialogVisible}
          style={{ width: "15vw" }}
          onHide={() => setIsDialogVisible(false)}
        >
          <div className="p-inputgroup">
            <TimeSpanInputs
              value={timeSpanToSeconds(currentTimeSpan as TimeSpan)}
              onChange={handleChangeEvent}
            />
          </div>
        </Dialog>
      </>
    );
  }
  return (
    <div
      style={{
        width: "100%",
        border: "none",
        backgroundColor: "transparent",
        color: "inherit",
        whiteSpace: "nowrap",
      }}
      className="p-inputtext"
    >
      {convertTimeSpanToString(timespan)}
    </div>
  );
}
